export default __webpack_public_path__ + "static/media/book-box.898f2e32.png";